import React from 'react';
import Styled from 'styled-components';
import * as color from '../colors';
import Button from './button';

const Article = Styled.article`
  display: grid;
  padding: 2rem 2rem;
  & > * {&:nth-child(2) {margin: 4rem 0;}}
  @media screen only and (max-width: 700px){
    place-items: center;
    place-content: center;
  }
`;
const Nav = Styled.nav`
  @media only screen and (max-width: 700px){
  justify-self: center;
  }
`;

const List = Styled.ul`
  display: flex;
`;

const Item = Styled.li`
  list-style: none;
  &:not(:first-child) {margin-left: 3rem};
`;

const Link = Styled.a.attrs(({ href }) => ({
  href,
}))`
  text-decoration: none;
  color: ${color.white};
  font-size: 2.3rem;
  transition: 0.2s ease;
  &:active {color: ${color.primaryAlt};};
  &:hover {border-bottom: solid 1px;};
  @media only screen and (max-width: 700px){
    font-size: 2rem;
  }
};
`;

const Heading = Styled.h1`
  color: ${color.white};
  line-height: 1.2;
  max-width: 15ch;
  margin-bottom: 4rem;
  font-size: 5rem;

  @media only screen and (max-width: 700px){
  text-align:center;
  justify-self:center;
  align-self:center;
  }
`;

const Footer = Styled.footer`
  @media only screen and (max-width: 700px){
  justify-self: center;
  text-align:center;
  }
`;

function BannerText() {
  return (
    <Article>
      <Nav>
        <List>
          <Item>
            <Link href="#about">About us</Link>
          </Item>
          <Item>
            <Link href="#reviews">Reviews</Link>
          </Item>
          <Item>
            <Link href="#services">Services</Link>
          </Item>
          <Item>
            <Link href="/register">Sign up</Link>
          </Item>
        </List>
      </Nav>

      <Heading>
        We care for your furry little loved ones while you're away
      </Heading>

      <Footer>
        <Button
          link={{ path: '/schedule' }}
          type="white"
          text="Schedule a visit"
          rounded
        />
      </Footer>
    </Article>
  );
}

export default BannerText;
